function Separator({ className }) {
  return <div className={`h-[1px] bg-red-900 ${className} mt-4`} />;
}

export default Separator;
